import { CircleSlash } from "lucide-react";
import { Link } from "react-router";
import { DocumentTitle } from "../components/DocumentTitle";

export function NotFoundPage() {
  return (
    <div className="page page--narrow">
      <DocumentTitle />
      <section className="panel status">
        <CircleSlash
          className="status-mark"
          size={28}
          strokeWidth={1.5}
          absoluteStrokeWidth
          aria-hidden="true"
        />
        <h1 className="status-title">Page not found</h1>
        <p className="status-body">The address you followed does not exist in this portal.</p>
        <div className="status-actions">
          <Link to="/" className="btn btn--primary">
            Back to Home
          </Link>
        </div>
      </section>
    </div>
  );
}
